import React from 'react';
import { Text } from '@chakra-ui/react';

import { KeyOpsTooltip } from '../../../components/KeyOpsTooltip';

// Formats a date string to be similar to "Mar 11 at 12:34 PM"
export function formatDateStringEditedTooltip(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const isDifferentYear = date.getFullYear() !== now.getFullYear();

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric', // Removes leading 0 from day
    year: isDifferentYear ? 'numeric' : undefined, // Include year if different
    hour: 'numeric', // Removes leading 0 from hour
    minute: '2-digit',
    hour12: true,
  };

  let formattedDate = date.toLocaleString('en-US', options);

  // Ensure correct placement of 'at'
  if (isDifferentYear) {
    const parts = formattedDate.split(', ');
    formattedDate = `${parts[0]}, ${parts[1]} at ${parts[2]}`;
  } else {
    formattedDate = formattedDate.replace(',', ' at');
  }

  return formattedDate;
}

export const EditedAtText = ({ editedAt }: { editedAt: string }) => {
  return (
    <KeyOpsTooltip label={formatDateStringEditedTooltip(editedAt)}>
      <Text
        style={{
          fontSize: 12,
          color: '#7C8DB5',
          display: 'inline',
        }}
      >
        &nbsp;&nbsp;{'Edited'}
      </Text>
    </KeyOpsTooltip>
  );
};
